import WithGrayLabel from 'components/WithGrayLabel'
import React from 'react'
import { IOrder } from './IOrder'

interface IOrderEndingLabelProps {
  order: IOrder
}

const OrderEndingLabel: React.FC<IOrderEndingLabelProps> = ({ order }) => {
  return (
    <>
      {order.edate && (
        <>
          {order.status_id === 2 ? (
            <WithGrayLabel label='Оплачен' nothingIfabsent>
              {order.edate}
            </WithGrayLabel>
          ) : order.status_id === 3 ? (
            <WithGrayLabel label='Отменен' nothingIfabsent>
              {order.edate}
            </WithGrayLabel>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  )
}
export default OrderEndingLabel
